import { Radius, Switch, Text } from '@sparemin/blockhead';
import * as React from 'react';
import { Col } from 'react-bootstrap';
import { DEFAULT_SLIDE_ASSET_BORDER_RADIUS_VW } from 'utils/constants';
import { block } from './utils';

export type SlideBorderRadiusFieldProps = {
  value?: number;
  onChange?: (value: number) => void;
};

const SlideBorderRadiusField: React.FC<SlideBorderRadiusFieldProps> = ({
  value,
  onChange,
}) => {
  return (
    <Col xs={12}>
      <div className={block('field-container')}>
        <div className={block('field-left-content')}>
          <div className={block('field-icon-container')}>
            <Radius height={40} width={40} />
          </div>

          <Text variant="label">Round corners</Text>
        </div>

        <Switch
          isSelected={!!value}
          className={block('field-switch')}
          onChange={isSelected =>
            onChange(isSelected ? DEFAULT_SLIDE_ASSET_BORDER_RADIUS_VW : 0)
          }
        />
      </div>
    </Col>
  );
};

export default SlideBorderRadiusField;
